export default {
  home: "/",
  books: "/books",
  lifestyle: "/lifestyle",
  readingChallenges: "/reading-challenges/the-bbc-big-read",
  about: "/about",
  tags: "/tags",
  authors: "/authors",
};
